var _circle, _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 271,
    viewBox: "0 0 229 271",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 114.5,
    r: 114.5,
    fill: "#FFECEC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 74.3438,
    y: 111.107,
    width: 99.9612,
    height: 138.835,
    rx: 11.1068,
    transform: "rotate(2.5 74.3438 111.107)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.4492,
    y: 105.611,
    width: 99.9612,
    height: 138.835,
    rx: 11.1068,
    transform: "rotate(-7.5 19.4492 105.611)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3861 116.427C21.6936 111.167 25.3965 106.341 30.6568 105.649L107.739 95.5007C113 94.8081 117.825 98.511 118.518 103.771L121.04 122.931L24.9086 135.587L22.3861 116.427Z",
    fill: "#FFECEC",
    stroke: "white",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 140.109,
    y: 96.728,
    width: 4.16505,
    height: 13.8835,
    rx: 2.08252,
    transform: "rotate(82.5 140.109 96.728)",
    fill: "#EC3337"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 102.07,
    y: 73.729,
    width: 4.16505,
    height: 13.8835,
    rx: 2.08252,
    transform: "rotate(-7.5 102.07 73.729)",
    fill: "#EC3337"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 126.477,
    y: 77.5176,
    width: 4.16505,
    height: 13.8835,
    rx: 2.08252,
    transform: "rotate(37.5 126.477 77.5176)",
    fill: "#EC3337"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9766,
    y: 141.508,
    width: 80.5243,
    height: 5.5534,
    rx: 2.7767,
    transform: "rotate(-7.5 33.9766 141.508)",
    fill: "#FFECEC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 37.6016,
    y: 169.037,
    width: 80.5243,
    height: 5.5534,
    rx: 2.7767,
    transform: "rotate(-7.5 37.6016 169.037)",
    fill: "#FFECEC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 41.2266,
    y: 196.567,
    width: 80.5243,
    height: 5.5534,
    rx: 2.7767,
    transform: "rotate(-7.5 41.2266 196.567)",
    fill: "#FFECEC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 35.4258,
    y: 152.52,
    width: 29.1553,
    height: 5.5534,
    rx: 2.7767,
    transform: "rotate(-7.5 35.4258 152.52)",
    fill: "#FFECEC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 39.0547,
    y: 180.049,
    width: 29.1553,
    height: 5.5534,
    rx: 2.7767,
    transform: "rotate(-7.5 39.0547 180.049)",
    fill: "#FFECEC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 42.6758,
    y: 207.579,
    width: 29.1553,
    height: 5.5534,
    rx: 2.7767,
    transform: "rotate(-7.5 42.6758 207.579)",
    fill: "#FFECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAnnouncement);
export default __webpack_public_path__ + "static/media/emptyAnnouncement.61c2547488e961baa57e00ddc2961dff.svg";
export { ForwardRef as ReactComponent };